//
export default [
    {
        text: 'código interno',
        value: 'internal_code',
        width: '15%',
    },
    {
        text: 'alias',
        value: 'alias_name',
    },
    {
        text: 'nombre',
        value: 'name',
    },
    {
        text: 'stock origen',
        value: 'stock',
        align: 'right',
        width: '15%',
    },
    {
        text: 'stock destino',
        value: 'stock_to',
        align: 'right',
        width: '15%',
    },
    {
        text: 'cantidad',
        value: 'quantity',
        align: 'right',
        input: {
            //min: 1,
            //nativeType: 'number',
            reverse: true,
            type: 'float-field',
        },
        width: '15%',
    },
]
